
// eslint-disable-next-line max-classes-per-file
import { Component, Prop, Vue } from 'vue-property-decorator';
import type {
  CanvasEventSource,
  CanvasMouseEvent,
  CanvasWheelEvent,
  Emitter,
  Registerer,
} from '../canvas/canvas-events';

import {
  ListenerAutoCleaner,
} from './ListenerAutoCleaner';

// Re-export useful types for label behaviors
export type {
  CanvasEventSource, CanvasMouseEvent, CanvasWheelEvent, Registerer, Emitter,
};

/**
 * The base component for all behaviors
 *
 * Provides:
 * * base render function (renderless)
 * * autoclean of events created using register
 * * possible extensions to emit and register
 */
@Component
export default class LabelBehavior<
  EmitExt extends Emitter = never,
  RegisterExt extends Registerer = Registerer,
> extends Vue {
  // Remove render
  render(): null { return null; }

  /**
   * The canvas event API
   */
  @Prop({ required: false })
  private canvas!: CanvasEventSource;

  private cleaner: ListenerAutoCleaner = null as unknown as ListenerAutoCleaner;

  mounted() {
    this.cleaner = new ListenerAutoCleaner(this.canvas);
  }

  /**
   * @override
   * type extensions to BaseBehavior.register
   * allows listening to events from other behaviors
   */
  protected get register(): RegisterExt {
    return this.cleaner.register.bind(this.cleaner) as RegisterExt;
  }

  /**
   * @override
   * type extensions to BaseBehavior.emit
   * allows emitting events to other behaviors
   */
  protected get emit(): EmitExt {
    return this.canvas.emit as EmitExt;
  }

  get canEmitOrRegister(): boolean {
    return !!this.canvas;
  }

  beforeDestroy() {
    this.cleaner.clear();
  }
}
